import { Button } from 'ra-ui-materialui'
import { FC, useCallback } from 'react'
import { useCreate, useNotify, useRefresh, useTranslate } from 'react-admin'
import ScheduleIcon from '@mui/icons-material/Schedule'

export const InstallNowButton: FC<{ certificateId: string }> = ({ certificateId }) => {
  const [create, { isLoading }] = useCreate()
  const notify = useNotify()
  const refresh = useRefresh()
  const translate = useTranslate()

  const handleClick = useCallback(() => {
    const now = new Date().toISOString()

    void create(
      'schedule',
      {
        data: {
          certificateId,
          installationDatum: now,
        },
      },
      {
        onSuccess: () => {
          notify('resources.schedule.actions.installationScheduledNow', { type: 'info' })
          refresh()
        },
      }
    )
  }, [certificateId, create, notify, refresh, translate])

  return (
    <Button
      label="resources.certificates.actions.installNow"
      variant="contained"
      startIcon={<ScheduleIcon />}
      onClick={handleClick}
      disabled={isLoading}
    />
  )
}